import { translate } from '#packages/i18n';
import { TRANSLATIONS } from '../../../translations';

import type { CompNamePlugin } from 'types/editorPlugins';

export const verticalAnchorsMenuCompNamePlugin: CompNamePlugin = () =>
  translate(TRANSLATIONS.ANCHORS_MENU_NAME);
